module.exports = "<div class=center-loading ng-show=$ctrl.NetworkService.loading ng-style=\"{'margin-top': $ctrl.marginTop}\"> <div class=loading-spinner></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/loading.html
// module id = 614
// module chunks = 0